<div class="list-container" *ngIf="openedDiscussions && openedDiscussions.length > 0; else emptyCase">
    <div *ngIf="!loading" class="cards-grid">
        <app-exam-card *ngFor="let disc of openedDiscussions; index as i" [exam]="disc.exam" [status]="disc.exam.status" [urgent]="false"
            [nonReads]="disc.non_reads" (clicked)="handleExamSelected($event)"></app-exam-card>
    </div>
    <span class="paginator-container" *ngIf="pageSize < count">
        <mat-paginator #paginator
                   class="paginator"
                   (page)="handlePageEvent($event)"
                   [length]="count"
                   [pageSize]="pageSize"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="[]"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="labels.PAGINATOR">
        </mat-paginator>
    </span>
</div>

<ng-template #emptyCase>
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>
  <!--<img *ngIf="loading" class="loading-img" src="images/loading_3.gif">-->
  <div *ngIf="!loading">
    {{ labels.NO_MESSAGES }}
  </div>
</ng-template>